var PropertyIcons;
(function (PropertyIcons) {
    // ImageId does not exist.
    PropertyIcons[PropertyIcons["None"] = -1] = "None";
    // Categories icon
    PropertyIcons[PropertyIcons["Categories"] = 0] = "Categories";
    // High Importance icon
    PropertyIcons[PropertyIcons["ImportanceHigh"] = 1] = "ImportanceHigh";
    // Attachment icon
    PropertyIcons[PropertyIcons["Attachment"] = 2] = "Attachment";
    // ImageId for replied mail.
    PropertyIcons[PropertyIcons["MailListViewReplied"] = 3] = "MailListViewReplied";
    // ImageId for forwarded mail.
    PropertyIcons[PropertyIcons["MailListViewForwarded"] = 4] = "MailListViewForwarded";
    // ImageId for IRM mail.
    PropertyIcons[PropertyIcons["MailListViewIRM"] = 5] = "MailListViewIRM";
    // ImageId for replied IRM mail.
    PropertyIcons[PropertyIcons["MailListViewIRMReplied"] = 6] = "MailListViewIRMReplied";
    // ImageId for forwarded IRM mail.
    PropertyIcons[PropertyIcons["MailListViewIRMForwarded"] = 7] = "MailListViewIRMForwarded";
    // ImageId for voice mail.
    PropertyIcons[PropertyIcons["MailListViewVoiceMailItem"] = 8] = "MailListViewVoiceMailItem";
    // ImageId for replied voice mail.
    PropertyIcons[PropertyIcons["MailListViewVoiceMailReplied"] = 9] = "MailListViewVoiceMailReplied";
    // ImageId for forwarded voice mail.
    PropertyIcons[PropertyIcons["MailListViewVoiceMailForwarded"] = 10] = "MailListViewVoiceMailForwarded";
    // ImageId for IRM voice mail.
    PropertyIcons[PropertyIcons["MailListViewVoiceMailIRM"] = 11] = "MailListViewVoiceMailIRM";
    // ImageId for fax.
    PropertyIcons[PropertyIcons["MailListViewFaxItem"] = 12] = "MailListViewFaxItem";
    // ImageId for appointment.
    PropertyIcons[PropertyIcons["MailListViewAppointmentItem"] = 13] = "MailListViewAppointmentItem";
    // ImageId for accepted appointment.
    PropertyIcons[PropertyIcons["MailListViewAppointmentAccepted"] = 14] = "MailListViewAppointmentAccepted";
    // ImageId for declined appointment.
    PropertyIcons[PropertyIcons["MailListViewAppointmentDeclined"] = 15] = "MailListViewAppointmentDeclined";
    // ImageId for tentative appointment.
    PropertyIcons[PropertyIcons["MailListViewAppointmentTentative"] = 16] = "MailListViewAppointmentTentative";
    // ImageId for canceled appointment.
    PropertyIcons[PropertyIcons["MailListViewAppointmentCanceled"] = 17] = "MailListViewAppointmentCanceled";
    // ImageId for contact
    PropertyIcons[PropertyIcons["MailListViewContactItem"] = 18] = "MailListViewContactItem";
    // ImageId for task
    PropertyIcons[PropertyIcons["MailListViewTaskItem"] = 19] = "MailListViewTaskItem";
    // ImageId for reoccurring task
    PropertyIcons[PropertyIcons["MailListViewTaskReocurItem"] = 20] = "MailListViewTaskReocurItem";
    // ImageId for journal.
    PropertyIcons[PropertyIcons["MailListViewJournalItem"] = 21] = "MailListViewJournalItem";
    // ImageId for post.
    PropertyIcons[PropertyIcons["MailListViewPostItem"] = 22] = "MailListViewPostItem";
    // ImageId for note.
    PropertyIcons[PropertyIcons["MailListViewNoteItem"] = 23] = "MailListViewNoteItem";
    // ImageId for delivery receipt.
    PropertyIcons[PropertyIcons["MailListViewDelivery"] = 24] = "MailListViewDelivery";
    // ImageId for non-delivery receipt.
    PropertyIcons[PropertyIcons["MailListViewNonDelivery"] = 25] = "MailListViewNonDelivery";
    // ImageId for approval request.
    PropertyIcons[PropertyIcons["MailListViewApprovalRequest"] = 26] = "MailListViewApprovalRequest";
    // ImageId for approval response of Approve.
    PropertyIcons[PropertyIcons["MailListViewResponseApprove"] = 27] = "MailListViewResponseApprove";
    // ImageId for approval response of Reject.
    PropertyIcons[PropertyIcons["MailListViewResponseReject"] = 28] = "MailListViewResponseReject";
    // ImageId for out of office message.
    PropertyIcons[PropertyIcons["MailListViewOutOfOffice"] = 29] = "MailListViewOutOfOffice";
    // ImageId for read report.
    PropertyIcons[PropertyIcons["MailListViewReadReport"] = 30] = "MailListViewReadReport";
    // ImageId for reminder message.
    PropertyIcons[PropertyIcons["MailListViewReminderMessage"] = 31] = "MailListViewReminderMessage";
    // ImageId for Smime.
    PropertyIcons[PropertyIcons["Smime"] = 32] = "Smime";
    // ImageId for TrustedSender icon
    PropertyIcons[PropertyIcons["TrustedSender"] = 33] = "TrustedSender";
    // ImageId for Charm icon
    PropertyIcons[PropertyIcons["Charm"] = 34] = "Charm";
    // ImageId for low importance icon
    PropertyIcons[PropertyIcons["ImportanceLow"] = 35] = "ImportanceLow";
    // ImageId for GlobalMentionedMe icon
    PropertyIcons[PropertyIcons["GlobalMentionedMe"] = 36] = "GlobalMentionedMe";
    // ImageId for Like icon
    PropertyIcons[PropertyIcons["Like"] = 37] = "Like";
    // ImageId for Snooze icon
    PropertyIcons[PropertyIcons["Snooze"] = 38] = "Snooze";
})(PropertyIcons || (PropertyIcons = {}));
export default PropertyIcons;
//# sourceMappingURL=PropertyIcons.js.map